import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Icon, cx, type ButtonVariant, type IconData } from '@sauda/ui/kit';

interface Props {
  variant?: ButtonVariant;
  size?: 'md' | 'lg';
  icon?: IconData;
  children: ReactNode;
  className?: string;
  /** A route inside the app, or an address that leaves it (opens in a new tab). */
  to?: string;
  href?: string;
  'aria-label'?: string;
}

/** A link that looks like a button: a call, a WhatsApp message or a move to another screen. */
export function LinkButton({
  variant = 'filled',
  size = 'md',
  icon,
  children,
  className,
  to,
  href,
  ...rest
}: Props) {
  const cls = cx(`k-btn k-btn--${variant} k-btn--${size} k-layer k-t-label-lg`, className);
  const body = (
    <>
      {icon === undefined ? null : <Icon icon={icon} size={18} />}
      <span className="k-btn__label">{children}</span>
    </>
  );
  if (to !== undefined)
    return (
      <Link className={cls} to={to} {...rest}>
        {body}
      </Link>
    );
  const external = href !== undefined && /^https?:/.test(href);
  return (
    <a
      className={cls}
      href={href}
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      {...rest}
    >
      {body}
    </a>
  );
}
